import { CourseRun } from "@/common/courseRun/types";
import getCourseRunStartDate from "./getCourseRunStartDate";
import {
  getI18nDateContextualString,
  getI18nDateString,
  getI18nDayMonthString,
  isEndingWithinThisYear,
} from "@/lib/date";
import { COURSE_PACING_SELF } from "./constants";
import type { CourseInfoTranslate } from "./getCourseInformation";

const getCourseRunTilePrimaryText = (
  courseRun: CourseRun,
  t: CourseInfoTranslate,
) => {
  const { isEnrollable, pacingType, start, end } = courseRun;
  const startDate = getCourseRunStartDate(courseRun);
  if (startDate) {
    // enrollable, not yet started
    if (start && isEnrollable && new Date(start) > new Date()) {
      const formattedStartDate = isEndingWithinThisYear(new Date(startDate))
        ? getI18nDayMonthString(startDate)
        : getI18nDateString(startDate);

      return t("startsDate", { date: formattedStartDate });
    }
    // enrollable, started, not ended
    if (isEnrollable && (!end || new Date(end) > new Date())) {
      // self-paced
      if (pacingType === COURSE_PACING_SELF) {
        return t("startsDate", {
          date: getI18nDayMonthString(new Date(startDate)),
        });
      }
      // instructor-paced
      return t("startedDate", {
        date: getI18nDayMonthString(new Date(startDate)),
      });
    }
  }
};

export const getCourseRunStartText = (
  courseRun: CourseRun,
  isDateOnly: boolean = false,
  t: CourseInfoTranslate,
) => {
  const { isEnrollable, pacingType, start, end } = courseRun;
  const startDate = getCourseRunStartDate(courseRun);
  if (startDate) {
    // enrollable, not yet started
    if (start && isEnrollable && new Date(start) > new Date()) {
      const formattedStartDate = getI18nDateContextualString(
        new Date(startDate),
      );
      return isDateOnly
        ? formattedStartDate
        : t("startsDate", { date: formattedStartDate });
    }
    // enrollable, started, not ended
    if (isEnrollable && (!end || new Date(end) > new Date())) {
      const formattedStartDate = getI18nDateContextualString(
        new Date(startDate),
      );
      // self-paced
      if (pacingType === COURSE_PACING_SELF) {
        return isDateOnly
          ? formattedStartDate
          : t("startsDate", { date: formattedStartDate });
      }
      // instructor-paced
      return isDateOnly
        ? formattedStartDate
        : t("startedDate", { date: formattedStartDate });
    }
    // For archived courses or other cases, still show the start date
    const formattedStartDate = getI18nDateContextualString(new Date(startDate));
    return isDateOnly
      ? formattedStartDate
      : t("startedDate", { date: formattedStartDate });
  }
  // Fallback if no start date is available
  return t("startDateTbd");
};

export default getCourseRunTilePrimaryText;
